import { Component } from '@angular/core';
import * as Highcharts from 'highcharts';
import { BaseChartComponent } from '../basechart/basechart.component';

@Component({
  selector: 'app-sankey',
  templateUrl: '../basechart/basechart.component.html',
})
export class SankeyComponent extends BaseChartComponent<Array<Highcharts.SeriesOptionsType>> {
  options: Highcharts.Options = {
    chart: {
      type: 'sankey',
    },
    title: {
      text: undefined,
    },
    tooltip: {
      headerFormat: null,
      pointFormat: '{point.fromNode.name} \u2192 {point.toNode.name}: {point.weight:.2f}',
    },
    legend: {
      layout: 'proximate',
      align: 'left',
    },
    series: undefined,
  };

  draw(renderingid: string) {
    this.options.title.text = this.title;
    this.options.series = this.data;
  }
}
